import React, { useState } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import { Drawer, Button, Modal } from 'antd';
import { Col, Row, Spin } from 'antd';
import MenuItems from './MenuItems';
import "./game-style.css";
import { ArrowBackRounded, ArrowForwardRounded, CheckCircleRounded, SearchRounded, AddCircleSharp } from '@mui/icons-material';
import GameLogoJpg from './images/GameLogo.jpg';
import img11Jpg from './images/img11.jpg';
import img2Jpg from './images/img2.jpg';
import img3Jpg from './images/img3.jpg';
import img4Jpg from './images/img4.jpg';
import img5Jpg from './images/img5.jpg';
import img6Jpg from './images/img6.jpg';
import img21Jpg from './images/img21.jpg';
import img22Jpg from './images/img22.jpg';
import img23Jpg from './images/img23.jpg';
import img24Jpg from './images/img24.jpg';
import img25Jpg from './images/img25.jpg';
import tabImgPng from './images/tabImg.png';
import aiPng from './images/ai.png';
import rightJpg from './images/right.jpg';
import SentryWrap from 'components/Sentry';

const { Sider, Content } = Layout;
function HomeGame() {
        const [collapsed, setCollapsed] = useState(false);

        const [visible, setVisible] = useState(false);
        const showDrawer = () => {
                setVisible(true);
        };
        const onClose = () => {
                setVisible(false);
        };

        const [selectedValue, setSelectedValue] = useState('');
        const handleChange = (event) => {
                setSelectedValue(event.target.value);
        };

        const [gameVisible, setgameVisible] = useState(false);
        const [currentScenario, setCurrentScenario] = useState(1);

        const showModal = () => {
                setgameVisible(true);
                setCurrentScenario(1);
        };

        const handleNext = () => {
                setCurrentScenario(currentScenario + 1);
        };

        // const handlePrevious = () => {
        //         setCurrentScenario(currentScenario - 1);
        // };

        const handleCancel = () => {
                setgameVisible(false);
        };

        const [gameVisibleEbk, setgameVisibleEbk] = useState(false);
        const [currentScenarioEbk, setCurrentScenarioEbk] = useState(1);

        const showModalEbk = () => {
                setgameVisibleEbk(true);
                setCurrentScenarioEbk(1);
        };

        const handleNextEbk = () => {
                setCurrentScenarioEbk(currentScenarioEbk + 1);
        };

        const handleCancelEbk = () => {
                setgameVisibleEbk(false);
        };

        return (
           <SentryWrap>
                <Layout>
                        {/* Website Menu Design */}
                        <div className="WebMenuLayout cmnTopSpc">
                                <Sider trigger={null} collapsible collapsed={collapsed}>
                                        <div className="menuLayout">
                                                <div className='gameLogo'>
                                                        <a><img src={GameLogoJpg} alt="" /></a>
                                                </div>
                                                <div className="addMenuItems">
                                                        <MenuItems onCreate={() => {
                                                                showModalEbk()
                                                        }} />
                                                </div>
                                        </div>
                                </Sider>
                        </div>
                        {/* End of Website Menu Design */}

                        <Layout>
                                {/* Mobile Menu Design */}
                                <nav className="menuBar">
                                        <div className="mobileMenuLayout">
                                                <Row>
                                                        <Col xs={{ span: 23 }} className="mobileMenuUpr">
                                                                <div className="mobileMenuSet">
                                                                        <div className='gameLogo'>
                                                                                <a><img src={GameLogoJpg} alt="" /></a>
                                                                        </div>
                                                                        <Button className="barsMenu" type="primary" onClick={showDrawer}>
                                                                                <span className="barsBtn"></span>
                                                                        </Button>
                                                                </div>
                                                        </Col>
                                                </Row>

                                                <Drawer
                                                        //title="Basic Drawer"
                                                        placement="left"
                                                        closable={false}
                                                        onClose={onClose}
                                                        visible={visible}
                                                        className="menuLayoutUpr">
                                                        <div className="menuLayout">
                                                                <div className='gameLogo'>
                                                                        <a><img src={GameLogoJpg} alt="" /></a>
                                                                </div>
                                                                <div className="addMenuItems">
                                                                        <MenuItems />
                                                                </div>
                                                        </div>
                                                </Drawer>
                                        </div>
                                </nav>
                                {/* End of Mobile Menu Design */}

                                <Content>

                                        <div className='gmHmRight cmnTopSpc'>
                                                <div className='welComeUser'>
                                                        <div className='welComeUserInr'>
                                                                <Button type="text"
                                                                        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                                                                        onClick={() => setCollapsed(!collapsed)}
                                                                />
                                                                <h1>Welcome, Claudia Alves!</h1>
                                                        </div>
                                                        <div className='welUsrRght'><a><ArrowBackRounded /><span>Back to Nosotros Online</span></a></div>
                                                </div>

                                                <Row className='filterRow'>
                                                        <Col xs={{ span: 24 }} lg={{ span: 16 }}>
                                                                <div className='filterBtns'>
                                                                        <Button onClick={showModal}>My 1Game's</Button>
                                                                        <Button>Other teachers </Button>
                                                                        <Button>Popular</Button>
                                                                        <Button>Trend</Button>
                                                                </div>
                                                        </Col>
                                                        <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                                                                <div className='filterSearch'>
                                                                        <SearchRounded />
                                                                        <input type="text" placeholder="Search" value="Search" />
                                                                </div>
                                                        </Col>
                                                </Row>

                                                <div className='myGames'>
                                                        <div className='myGamesList'>
                                                                <div><img src={img11Jpg} alt="" /></div>
                                                                <label>Anecdotas Inicial 1</label>
                                                        </div>
                                                        <div className='myGamesList'>
                                                                <div><img src={img2Jpg} alt="" /></div>
                                                                <label>Anecdotas</label>
                                                        </div>
                                                        <div className='myGamesList'>
                                                                <div><img src={img3Jpg} alt="" /></div>
                                                                <label>Anecdotas Inicial</label>
                                                        </div>
                                                        <div className='myGamesList'>
                                                                <div><img src={img4Jpg} alt="" /></div>
                                                                <label>Anecdotas 2</label>
                                                        </div>
                                                        <div className='myGamesList'>
                                                                <div><img src={img5Jpg} alt="" /></div>
                                                                <label>Anecdotas 3</label>
                                                        </div>
                                                        <div className='myGamesList'>
                                                                <div><img src={img6Jpg} alt="" /></div>
                                                                <label>Anecdotas 4</label>
                                                        </div>
                                                        <div className='myGamesList'>
                                                                <div><img src={img3Jpg} alt="" /></div>
                                                                <label>Anecdotas Inicial</label>
                                                        </div>

                                                </div>

                                                <div className='dropDwnCard'>
                                                        <select value={selectedValue} onChange={handleChange}>
                                                                <option value="" disabled>Select</option>
                                                                <option value={10}>Option 1</option>
                                                                <option value={20}>Option 2</option>
                                                                <option value={30}>Option 3</option>
                                                        </select>
                                                </div>

                                                <div className='myUnits'>
                                                        <div className='myUnitsGm'>
                                                                <div className='myUnitsBnr'><img src={img21Jpg} alt="" /></div>
                                                                <div className='myUnitsTxt'>
                                                                        <div className='myUnitsInfo'>
                                                                                <label>La Familla Primero</label>
                                                                                <p>Anecdotas 5</p>
                                                                                <span>Pg. 12</span>
                                                                        </div>
                                                                        <div className='myUnitsBtns'>
                                                                                <a className='BtnsPrev'>Preview</a>
                                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                                        </div>
                                                                        <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                                </div>
                                                        </div>

                                                        <div className='myUnitsGm'>
                                                                <div className='myUnitsBnr'><img src={img22Jpg} alt="" /></div>
                                                                <div className='myUnitsTxt'>
                                                                        <div className='myUnitsInfo'>
                                                                                <label>La Familla Primero</label>
                                                                                <p>Anecdotas 2</p>
                                                                                <span>Pg. 12</span>
                                                                        </div>
                                                                        <div className='myUnitsBtns'>
                                                                                <a className='BtnsPrev'>Preview</a>
                                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                                        </div>
                                                                        <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                                </div>
                                                        </div>

                                                        <div className='myUnitsGm'>
                                                                <div className='myUnitsBnr'><img src={img23Jpg} alt="" /></div>
                                                                <div className='myUnitsTxt'>
                                                                        <div className='myUnitsInfo'>
                                                                                <label>La Familla Primero</label>
                                                                                <p>Anecdotas 1</p>
                                                                                <span>Pg. 12</span>
                                                                        </div>
                                                                        <div className='myUnitsBtns'>
                                                                                <a className='BtnsPrev'>Preview</a>
                                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                                        </div>
                                                                        <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                                </div>
                                                        </div>

                                                        <div className='myUnitsGm'>
                                                                <div className='myUnitsBnr'><img src={img24Jpg} alt="" /></div>
                                                                <div className='myUnitsTxt'>
                                                                        <div className='myUnitsInfo'>
                                                                                <label>La Familla Primero</label>
                                                                                <p>Anecdotas 3</p>
                                                                                <span>Pg. 12</span>
                                                                        </div>
                                                                        <div className='myUnitsBtns'>
                                                                                <a className='BtnsPrev'>Preview</a>
                                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                                        </div>
                                                                        <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                                </div>
                                                        </div>

                                                        <div className='myUnitsGm'>
                                                                <div className='myUnitsBnr'><img src={img25Jpg} alt="" /></div>
                                                                <div className='myUnitsTxt'>
                                                                        <div className='myUnitsInfo'>
                                                                                <label>La Familla Primero</label>
                                                                                <p>Anecdotas 4</p>
                                                                                <span>Pg. 12</span>
                                                                        </div>
                                                                        <div className='myUnitsBtns'>
                                                                                <a className='BtnsPrev'>Preview</a>
                                                                                <a className='BtnsStart'><ArrowForwardRounded />start</a>
                                                                        </div>
                                                                        <div className='myUnitsBtm'><p><CheckCircleRounded /> One Way Education</p></div>
                                                                </div>
                                                        </div>


                                                </div>
                                        </div>

                                </Content>
                        </Layout>

                        <div className='gmScenarioUpr'>
                                <div className='gmScenario'>
                                        <Modal
                                                visible={gameVisible}
                                                onCancel={handleCancel}
                                                className={`scenarioMdlWrap ${currentScenario === 2 ? 'gmScenarioSecond' : ''}`}
                                        // footer={[
                                        //         <Button key="previous" disabled={currentScenario === 1} onClick={handlePrevious}>
                                        //                 Previous
                                        //         </Button>,
                                        //         <Button key="next" disabled={currentScenario === 4} onClick={handleNext}>
                                        //                 Next
                                        //         </Button>,
                                        // ]}
                                        >
                                                <div>
                                                        {currentScenario === 1 && <div className='aiGmMdl'>
                                                                <div className='aiMdlLbl'><label>Create your 1Game!</label></div>
                                                                <div className='aiGmMdlInr'>
                                                                        <div className='aiMdlOvr'><a><span>Blank template</span> <img src={tabImgPng} alt="" /></a></div>
                                                                        <div className='aiMdlOvr'><a onClick={handleNext}><span><label>AI Generator</label> using a general topic</span> <img src={aiPng} alt="" /></a></div>
                                                                </div>
                                                        </div>
                                                        }
                                                        {currentScenario === 2 && <div className='writeTpcUpr'>
                                                                <div className='writeTpc'>
                                                                        <p>Write your topic or choose one from below</p>
                                                                        <img src={aiPng} alt="" />
                                                                </div>
                                                                <div className='writeTpcBtns'>
                                                                        <Button>Family</Button>
                                                                        <Button>Hispanic Food</Button>
                                                                        <Button>Hispanic Celebrations</Button>
                                                                        <Button>Hispanic Celebrations</Button>
                                                                        <Button>Peace</Button>
                                                                        <Button>Values</Button>
                                                                        <Button>Hispanic Cities</Button>
                                                                        <Button>Hispanic History</Button>
                                                                        <Button>Friendship</Button>
                                                                        <Button>Respect Each</Button>
                                                                        <Button>Respect Art</Button>
                                                                        <Button>Hispanic History</Button>
                                                                </div>
                                                        </div>
                                                        }
                                                </div>

                                        </Modal>
                                </div>
                        </div>

                        {/* Model design for the Ebook screen */}
                        <div className='gmScenarioUpr'>
                                <div className='gmScenario'>
                                        <Modal
                                                visible={gameVisibleEbk}
                                                onCancel={handleCancelEbk}
                                                className={`scenarioMdlWrap ${currentScenarioEbk >= 2 ? 'gmScenarioSecond' : ''}`}
                                        >
                                                <div>
                                                        {currentScenarioEbk === 1 && <div className='aiGmMdl'>
                                                                <div className='aiMdlLbl'><label>Create your 1Game!</label></div>
                                                                <div className='aiGmMdlInr'>
                                                                        <div className='aiMdlOvr'><a><span>Blank template</span> <img src={tabImgPng} alt="" /></a></div>
                                                                        <div className='aiMdlOvr'><a onClick={handleNextEbk}><span><label>AI Generator</label> using this section content</span> <img src={aiPng} alt="" /></a></div>
                                                                        <div className='aiMdlOvr'><a onClick={handleNextEbk}><span><label>AI Generator</label> using this topic</span> <img src={aiPng} alt="" /></a></div>
                                                                </div>
                                                        </div>
                                                        }
                                                        {currentScenarioEbk === 2 && <div className='writeTpcUpr'>
                                                                <div className='writeTpcEbk'>
                                                                        <p>Choose from what section of this page you want us to create!</p>
                                                                        <img src={aiPng} alt="" />
                                                                </div>
                                                                <div className='choseQuesUpr'>
                                                                        <div onClick={handleNextEbk}>
                                                                                <p>Create questions from the entire article</p>
                                                                        </div>
                                                                        <div onClick={handleNextEbk}>
                                                                                <p>Create questions using the vocabulary words</p>
                                                                        </div>
                                                                        <div onClick={handleNextEbk}>
                                                                                <p>Create reflexive questions using the main topic</p>
                                                                        </div>
                                                                        <div onClick={handleNextEbk}>
                                                                                <p>Create reflexive questions using the main topic</p>
                                                                        </div>
                                                                </div>
                                                        </div>
                                                        }
                                                        {currentScenarioEbk === 3 && <div className='yourMagic'>
                                                                <div className='yourMagicImg'><img src={aiPng} alt="" /></div>
                                                                <div className='yourMagicTxt' onClick={handleNextEbk}><p>Working on your magic!</p></div>
                                                                <div className="maginSpinner">
                                                                        <Spin size="large" indicator={
                                                                                <div className="magicIndicator">
                                                                                        <div className="dot" />
                                                                                        <div className="dot" />
                                                                                        <div className="dot" />
                                                                                        <div className="dot" />
                                                                                </div>
                                                                        } />
                                                                </div>
                                                        </div>
                                                        }
                                                        {currentScenarioEbk === 4 && <div className='writeTpcUpr'>
                                                                <div className='writeTpcEbk'>
                                                                        <p>Your questions are ready for your selection!</p>
                                                                        <img src={aiPng} alt="" />
                                                                </div>
                                                                <div className='quesSelect'>
                                                                        <div className='quesSelectTxt'><p>Title: EI 14 de febrero, amor o mercadeo?</p></div>

                                                                        <div className='quesSelectTxt'>
                                                                                <Button>Select<AddCircleSharp /></Button>
                                                                                <p>1. Origen del Dia de san valentin:</p>
                                                                                <p>A. Roma Antigua</p>
                                                                                <p>B. Grecia Moderna <img src={rightJpg} alt="" /></p>
                                                                                <p>C. Egipto Antiguo</p>
                                                                                <p>D. Edad Media Europea</p>
                                                                        </div>
                                                                        <div className='quesSelectTxt'>
                                                                                <Button>Select<AddCircleSharp /></Button>
                                                                                <p>1. Origen del Dia de san valentin:</p>
                                                                                <p>A. Roma Antigua</p>
                                                                                <p>B. Grecia Moderna <img src={rightJpg} alt="" /></p>
                                                                                <p>C. Egipto Antiguo</p>
                                                                                <p>D. Edad Media Europea</p>
                                                                        </div>

                                                                </div>
                                                        </div>
                                                        }
                                                </div>

                                        </Modal>
                                </div>
                        </div>
                        {/* End of the Model design for the Ebook screen */}

                </Layout>
            </SentryWrap>
        );
}

export default HomeGame;  